<script setup lang="ts">
type Slots = {
  icon?(): any;
  title?(): any;
  description(): any;
};

defineSlots<Slots>();
defineProps<{
  iconKey?: keyof typeof iconPackMapper;
}>();
</script>

<template>
  <div class="flex gap-4 py-2 text-platform-text-3 items-start">
    <BaseIcon
      v-if="iconKey"
      :name="iconKey"
      :size="24"
    />
    <slot
      v-else-if="$slots.icon"
      name="icon"
    />

    <div class="flex flex-col gap-0.5">
      <h2 class="uppercase font-bold text-sm text-platform-text-1">
        <slot name="title" />
      </h2>
      <p
        v-if="$slots.description && $slots.description()"
        class="text-xs"
      >
        <slot name="description" />
      </p>
    </div>
  </div>
</template>
